// INFO: Do not change the order of the enum values
export enum TunnelTemplateVersion {
  V1_0_21 = '1.0.21',
  V1_0_22 = '1.0.22',
  V1_0_23 = '1.0.23',
  V1_0_24 = '1.0.24',
  V2_0_0 = '2.0.0',
  V2_1_0 = '2.1.0',
  V2_1_3 = '2.1.3',
  V2_1_4 = '2.1.4',
  V2_2_0 = '2.2.0',
  V2_2_2 = '2.2.2',
  V2_2_3 = '2.2.3',
  V2_2_4 = '2.2.4',
  V2_2_5 = '2.2.5',
  V3_0_0 = '3.0.0',
  V3_0_1 = '3.0.1',
  V3_1_0 = '3.1.0',
  V3_1_1 = '3.1.1',
  V3_1_2 = '3.1.2',
  V4_0_0 = '4.0.0',
  V5_0_0 = '5.0.0',
  V5_1_0 = '5.1.0',
}
